"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.referralChartCreator = void 0;
const Plot = __importStar(require("@observablehq/plot"));
const viem_1 = require("viem");
const referralChartCreator = (chartRef, rows, clearChart) => {
    if (!chartRef?.current) {
        return;
    }
    const width = chartRef.current.clientWidth;
    const height = 400;
    const chart = Plot.plot({
        width: Math.min(width, 780),
        height,
        marginLeft: 70,
        marginRight: 50,
        marginBottom: 40,
        style: {
            background: "inherit",
        },
        y: {
            axis: "left",
            grid: true,
            label: "Sold items",
            nice: true,
            labelAnchor: "top",
            labelOffset: 40,
        },
        x: {
            label: "Date",
            type: "band",
            line: true,
            nice: true,
            labelAnchor: "center",
            transform: (d) => new Date(d),
        },
        marks: [
            Plot.barY(rows, { y: "count", x: "date", fill: "#ccc" }),
            () => Plot.plot({
                width: Math.min(width, 780),
                height,
                marginLeft: 70,
                marginRight: 50,
                marginBottom: 40,
                style: {
                    background: "inherit",
                },
                x: {
                    type: "band",
                    axis: null,
                    nice: true,
                    transform: (d) => new Date(d),
                },
                y: {
                    axis: "right",
                    label: "Gained profit",
                    line: true,
                    nice: true,
                    transform: (d) => Number((0, viem_1.parseEther)(d) / (0, viem_1.parseEther)(String(1e15))),
                },
                marks: [
                    Plot.line(rows, {
                        y: "amount",
                        x: "date",
                        curve: "catmull-rom",
                        marker: "circle",
                    }),
                ],
                color: {
                    scheme: "cool",
                },
            }),
        ],
        color: {
            scheme: "cool",
        },
    });
    clearChart();
    chartRef.current.append(chart);
};
exports.referralChartCreator = referralChartCreator;
//# sourceMappingURL=referral-chart-creator.js.map